import React from "react";

import { TagProps, _Tag } from "./_Tag";

type TagType = Omit<TagProps, "fill" | "color">;

export function PrimaryTag({
  type = "bold",
  testID = "primary-tag",
  ...props
}: TagType) {
  if (type === "bold")
    return (
      <_Tag
        fill="background-accent-blue-strong"
        testID={testID}
        color="text-accent-blue-weak"
        {...props}
      />
    );

  return (
    <_Tag
      fill="background-accent-blue-weak"
      color="text-accent-blue-strong"
      testID={testID}
      {...props}
    />
  );
}
